import { Routes } from '@angular/router';
import { tenantGuard } from './core/guards/tenant.guard';
import { authGuard } from './core/guards/auth.guard';
import { langGuard } from './core/guards/lang.guard';
import { jobDetailResolver } from './pages/job-detail/job-detail.resolver';

const publicChildren: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
    },
    {
        path: 'careers',
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/job-vacancy/job-vacancy.component').then(m => m.JobVacancyComponent),
            },
            {
                path: 'invitation',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./pages/job-invitation/job-invitation.component').then(m => m.JobInvitationComponent),
                    },
                    {
                        path: ':job_invitation_uuid',
                        loadComponent: () => import('./pages/job-invitation/job-invitation.component').then(m => m.JobInvitationComponent),
                    }
                ],
            },
            {
                path: 'application/:job_application_id/update-form',
                loadComponent: () => import('./pages/job-application-update-form/job-application-update-form.component').then(m => m.JobApplicationUpdateFormComponent),
                // canActivate: [authGuard],
            },
            {
                path: ':job_vacancy_slug',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./pages/job-detail/job-detail.component').then(m => m.JobDetailComponent),
                        resolve: {
                            jobDetail: jobDetailResolver,
                        },
                    },
                    {
                        path: 'apply',
                        loadComponent: () => import('./pages/job-apply/job-apply.component').then(m => m.JobApplyComponent),
                        canActivate: [authGuard],
                    },
                    {
                        path: '**',
                        redirectTo: '../../not-found',
                    },
                ],
            },
            {
                path: '**',
                redirectTo: 'careers',
            },
        ],
    },
    {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [authGuard],
    },
    {
        path: 'account',
        loadComponent: () => import('./pages/account/account.component').then(m => m.AccountComponent),
        canActivate: [authGuard],
    },
    {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    },
    {
        path: '**',
        redirectTo: '',
    },
];

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'en',
        pathMatch: 'full',
    },
    {
        path: 'maintenance',
        loadComponent: () => import('./pages/maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
        canActivate: [tenantGuard],
    },
    {
        path: ':lang',
        canActivate: [langGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/layout/layout.component').then(m => m.LayoutComponent),
                canActivate: [tenantGuard],
                children: publicChildren,
            },
        ],
    },
    {
        path: 'pages',
        children: [
            {
                path: '',
                redirectTo: '/en',
                pathMatch: 'full',
            },
            {
                path: '**',
                redirectTo: '/en',
            },
        ],
    },
    { path: '**', redirectTo: 'en' },
];
